<nav [class.white]="!blue" [class.blue]="blue" class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
	<div class="container">
		<div class="navbar-brand">
			<a routerLink="/" class="navbar-item">
				<img src="/assets/img/logo.svg" width="100%" style="max-height: 100%" />
			</a>
			<a (click)="toggleMenu()" role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarButtons">
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>
		</div>

		<div [class.is-active]="menuOpened" id="navbarButtons" class="navbar-menu">
			<div class="navbar-end">
				<ng-container *ngIf="showCalibrationsNav">
					<a (click)="menuOpened = false" routerLink="/servicios" class="navbar-item">
						Servicios
					</a>
					<div class="navbar-item has-dropdown is-hoverable">
						<a class="navbar-link">Equipo</a>
						<div class="navbar-dropdown">
							<a (click)="menuOpened = false" routerLink="/equipo/venta" class="navbar-item">Venta</a>
							<a (click)="menuOpened = false" routerLink="/equipo/reparacion" class="navbar-item">Reparación</a>
						</div>
					</div>
					<a (click)="menuOpened = false" routerLink="/capacitacion" class="navbar-item">
						Capacitacion
					</a>
					<a (click)="menuOpened = false" routerLink="/nosotros" class="navbar-item">
						Nosotros
					</a>
					<a (click)="menuOpened = false" routerLink="/acreditaciones" class="navbar-item">
						Acreditaciones
					</a>
					<a (click)="menuOpened = false" routerLink="/contacto" class="navbar-item">
						Contacto
					</a>
				</ng-container>
				<div (click)="menuOpened = false" class="navbar-item" *ngIf="areaButtonText">
					<a [routerLink]="[areaButtonLink]" class="button is-danger">
						{{ areaButtonText }}
					</a>
				</div>
			</div>
		</div>
	</div>
</nav>
